import { CombinedMode } from '@/components/CombinedMode';
import { SplitMode } from '@/components/SplitMode';
import { CombinedView } from './views/combined';
import { LenderView } from './views/lender';
import { BorrowerView } from './views/borrower';

const FundraisingPage = () => {
  return (
    <>
      <CombinedMode>
        <CombinedView />
      </CombinedMode>
      <SplitMode
        lender={<LenderView />}
        borrower={<BorrowerView />}
      />
    </>
  );
};

export default FundraisingPage;
